import { LumeFxSide } from '@/types/lumeFx';
import useLanguage from '@/utils/hooks/useLanguage';
import { RadioGroup } from '@headlessui/react';
import cn from 'classnames';

interface FormOrderTypeSwitchProps {
    initialValue: LumeFxSide;
    onChange: any;
    disabled?: boolean;
    // onChange: (side: Side) => void;
}

export default function FormOrderTypeSwitch(props: FormOrderTypeSwitchProps) {
    const lang = useLanguage();
    return (
        <RadioGroup value={props.initialValue} onChange={props.onChange}>
            <div className="flex flex-row rounded-sm overflow-hidden text-sm uppercase p-1 bg-brand-neutral-700">
                <RadioGroup.Option value={LumeFxSide.BUY} className="w-1/2 text-center focus:outline-none">
                    {({ checked }) => {
                        const buyButtonClassname = cn(
                            // border border-r-0 border-brand-green
                            'p-3 cursor-pointer transition-colors rounded-sm',
                            {
                                'bg-brand-green': checked,
                                'text-brand-neutral-400 hover:text-white': !checked,
                                'cursor-not-allowed': props.disabled
                            }
                        );
                        return <div className={buyButtonClassname}>{lang.orderForm.buy}</div>;
                    }}
                </RadioGroup.Option>
                <RadioGroup.Option value={LumeFxSide.SELL} className="w-1/2 text-center focus:outline-none">
                    {({ checked }) => {
                        const sellButtonClassname = cn(
                            // border border-l-0 border-brand-red
                            'p-3 cursor-pointer transition-colors rounded-sm',
                            {
                                'bg-brand-red': checked,
                                'text-brand-neutral-400 hover:text-white': !checked,
                                'cursor-not-allowed': props.disabled
                            }
                        );
                        return <div className={sellButtonClassname}>{lang.orderForm.sell}</div>;
                    }}
                </RadioGroup.Option>
            </div>
        </RadioGroup>
    );
}
